import {
  FunctionField,
  ReferenceField,
  Show,
  SimpleShowLayout,
  TextField,
  type ShowProps,
} from "react-admin";
import DisplayDateField from "@/components/DisplayDateField";

import {
  formatAttendanceChannel,
  formatAttendanceMatchSource,
  formatCheckedInBy,
  formatOptionalText,
  formatYesNo,
} from "./miqaat-attendance-display";

export default function MiqaatAttendanceShow(props: ShowProps) {
  return (
    <Show {...props}>
      <SimpleShowLayout>
        <ReferenceField source="miqaatId" reference="miqaats" link="show">
          <TextField source="name" />
        </ReferenceField>
        <ReferenceField source="venueId" reference="miqaatVenues" emptyText="—">
          <TextField source="name" />
        </ReferenceField>
        <DisplayDateField source="occurrenceDate" label="Occurrence date" emptyText="—" />
        <TextField source="attendeeIts" label="ITS" emptyText="—" />
        <TextField source="attendeeName" label="Name" emptyText="—" />
        <TextField source="attendeeKey" label="Attendee key" emptyText="—" />
        <FunctionField
          label="Channel"
          render={(record: { channel?: unknown }) => formatAttendanceChannel(record?.channel)}
        />
        <FunctionField
          label="Match source"
          render={(record: { matchSource?: unknown }) =>
            formatAttendanceMatchSource(record?.matchSource)
          }
        />
        <FunctionField
          label="RSVP on file"
          render={(record: { rsvpOnFile?: unknown }) => formatYesNo(record?.rsvpOnFile)}
        />
        <TextField source="phone" label="Phone" emptyText="—" />
        <TextField source="jamaatMohalla" label="Jamaat / Mohalla" emptyText="—" />
        <TextField source="notes" label="Notes" emptyText="—" />
        <FunctionField
          label="Checked in by"
          render={(record: Record<string, unknown>) => formatCheckedInBy(record)}
        />
        <FunctionField
          label="Checked in by key"
          render={(record: { checkedInByAttendeeKey?: unknown }) =>
            formatOptionalText(record?.checkedInByAttendeeKey)
          }
        />
        <FunctionField
          label="Check-in GPS"
          render={(record: { checkInLatitude?: unknown; checkInLongitude?: unknown }) => {
            if (record?.checkInLatitude == null || record?.checkInLongitude == null) {
              return "—";
            }
            return `${String(record.checkInLatitude)}, ${String(record.checkInLongitude)}`;
          }}
        />
        <DisplayDateField source="createdAt" showTime emptyText="—" />
      </SimpleShowLayout>
    </Show>
  );
}
